import { render, staticRenderFns } from "./hizliSatis.vue?vue&type=template&id=2977d166&scoped=true&"
import script from "./hizliSatis.vue?vue&type=script&lang=js&"
export * from "./hizliSatis.vue?vue&type=script&lang=js&"
import style0 from "./hizliSatis.vue?vue&type=style&index=0&id=2977d166&lang=scss&scoped=true&"
import style1 from "./hizliSatis.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2977d166",
  null
  
)

export default component.exports